import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { useStateValue } from '../../context/store';
import { getMaestras } from '../../actions/generation-contarct-action';
import { createMedicalExam, getExamType } from '../../actions/medical-exam-action';
import { getActiveRegionals } from '../../actions/regional-actions';
import { getChargesByStatusActive } from '../../actions/charge-actions';
import ModalConfirmBase from '../../utils/form/modalConfirmBase';
import FormCreateOrderExam from './create order/formCreateOrderExam';
import NextFormCreateOrder from './create order/nextFormCreateOrder';
import { styleExam } from './styleExam';
import { permissionsConstans } from '../../constansPermissions';
import NotAuthorized from '../notAuthorized';
import { getEmployeeData } from '../../actions/permissions-actions';

const CreateorderExam = (props) => {
  const classes = styleExam();
  const [{}, dispatch] = useStateValue();
  const [dataMaestras, setDataMaestras] = useState([]);
  const [isContinue, setIsContinue] = useState(false);
  const [regional, setRegional] = useState([]);
  const [charges, setCharges] = useState([]);
  const [stateInitial, setStateInitial] = useState({});
  const [userState, setUserState] = useState({});
  const [typeExam, setTypeExam] = useState([]);
  const [isFieldDisabled, setIsFieldDisabled] = useState(false);

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    threeButtons: false,
    type: "",
    open: false,
  });

  const handleClose = () => {
    setMessage({ ...message, open: false });
  }

  const handleCloseRedirect = () => {
    setMessage({ ...message, open: false });
    props.history.push('/dashboard/medicalExams');
  }

  const returnMessageRequest = (msg, type, handleClick) => {
    isDisabledBtnGenerateExam(false);
    setMessage({
      description:  msg,
      textButtonSubmit: "Aceptar",
      handleClick: () => handleClick(),
      oneButtons: true,
      type: type,
      open: true,
    });
  }

  const isDisabledBtnGenerateExam = (state) => {
    dispatch({
      type: 'IS_DISABLED_BTN_EXAM',
      stateBtn: state
    })
  }

  const handleClickExam = async (data) => {
    isDisabledBtnGenerateExam(true);
    setMessage({ ...message, open: false });
    const response = await createMedicalExam(data);
    if(response?.status === 200 || response?.status === 201){
      const msg = 'Su orden de examen médico ha sido generada de manera exitosa';
      const type = 'SUCCESS';
      returnMessageRequest(msg, type, handleCloseRedirect);
    }else if(response?.status > 399 && response?.status !== 401 && response?.status !== 403 ){
      const msg = response?.data?.detail
      ? response?.data?.detail
      : 'Su orden de examen médico no ha sido generada';
      const type = 'WARNING';
      returnMessageRequest(msg, type, handleClose);
    }else{
      const msg = 'Ocurrió un error procesando la solicitud, inténtelo nuevamentes';
      const type = 'WARNING';
      returnMessageRequest(msg, type, handleClose);
    }
  }

  useEffect(() => {
    const getRegional = async () => {
      const response = await getActiveRegionals();
      setRegional(response?.data?.regionalList);
    }
    getRegional();
  }, []);

  useEffect(() => {
    const getDataMaestras = async() => {
      const resp = await getMaestras();
      setDataMaestras(resp?.data);
    }
    getDataMaestras();
  }, []);

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Generar orden exámenes médicos",
      breadCrumbSubText: "Generar orden exámenes médicos",
      index: 24,
    });
  }, [dispatch])

  const allTypeExam = async () => {
    const response = await getExamType();
    if(response?.data){
      let otro = response?.data.find(t=> t.description === "Otro");
      let others = response?.data.filter(t=>t.description !== "Otro");
      const list =others.concat(otro);
      setTypeExam(list);
    }
  }

  useEffect(() => {
    allTypeExam();
    const getAllCharges = async () => {
      const response = await getChargesByStatusActive();
      setCharges(response?.data?.chargeList);
    };
    getAllCharges();
  }, []);

  const onSubmit = (data) => {
    getPerson(data);
  }

  const getPerson = async (data) => {
    //const response = await getPersonByDocumentAndType(data?.document, data?.documentType, dispatch);
    const response = await getEmployeeData(data?.document, data?.documentType, dispatch);
    setUserState(response?.data);
    if(response?.data?.id){
      setIsFieldDisabled(true);
    }else{
      setIsFieldDisabled(false);
    }
    setStateInitial(data);
    setIsContinue(true);
  }

  const validationPermissionCreateExam = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "EXAM_MED");

    if (module?.functionalities?.some(
        (x) => x === permissionsConstans.EXAM_MED_CREAR
      )
    ) {
      return (
        <React.Fragment>
          <FormCreateOrderExam
            dataMaestras={dataMaestras}
            onSubmit={onSubmit}
          />
        </React.Fragment>
      );
    } else {
      return(
        <React.Fragment>
          <NotAuthorized />
        </React.Fragment>
      )
    };
  };

  return (
    <div className={classes.divCreateOrder}>
      <Grid container>
        {!isContinue
            ? validationPermissionCreateExam()
            : null
        }
        {isContinue
          ? <NextFormCreateOrder
              dataMaestras={dataMaestras}
              regional={regional}
              charges={charges}
              stateInitial={stateInitial}
              setMessage={setMessage}
              message={message}
              handleClickExam={handleClickExam}
              userState={userState}
              typeExam={typeExam}
              isFieldDisabled={isFieldDisabled}
            />
          : null
        }
      </Grid>
      <ModalConfirmBase
          description={message.description}
          textButtonSubmit={message.textButtonSubmit}
          handleClick={message.handleClick}
          handleClickOut={message.handleClickOut}
          oneButtons={message.oneButtons}
          threeButtons={message.threeButtons}
          type={message.type}
          open={message.open}
        />
    </div>
  )
}

export default CreateorderExam